import axios from "axios";
import convertDateFormat from "../Utils/convertDateFormat";

const BASEURL =
  "https://portal.monetare.com.br/rest/34/ca7m4u1v6nzm33n2/crm.lead.add.json";

const BitrixApi = ({
  bank,
  nomeCompleto,
  cpf,
  idadeCliente,
  emailPrincipal,
  numero,
  linkSimulacao,
  cgi,
  triggerSuccess,
  valorImovel,
  valorFinaciamento,
}) => {
  function verificationIdBank(bank) {
    switch (bank) {
      case "./assets/brb.svg":
        return "38";
      case "./assets/bradesco.svg":
        return "506";
      case "./assets/caixa.svg":
        return "512";
      case "./assets/santander.svg":
        return "536";
      case "./assets/itau.svg":
        return "532";
      case "./assets/inter.svg":
        return "528";
      default:
        return "erro";
    }
  }

  function verifyProduct(product) {
    return product === "FIN" ? "221176" : "221178";
  }

  axios
    .post(BASEURL, {
      fields: {
        TITLE: nomeCompleto.toString(),
        UF_CRM_1730921518638: cpf.toString(),
        UF_CRM_1730921549389: convertDateFormat(idadeCliente),
        PHONE: [
          {
            ID: "34038",
            VALUE_TYPE: "WORK",
            VALUE: "+55" + numero.toString(),
            TYPE_ID: "PHONE",
          },
        ],
        EMAIL: [
          {
            ID: "34040",
            VALUE_TYPE: "WORK",
            VALUE: emailPrincipal,
            TYPE_ID: "EMAIL",
          },
        ],
        UF_CRM_1739301033: verificationIdBank(bank),
        UF_CRM_676F602A08CCC: verifyProduct(cgi),
        ASSIGNED_BY_ID: "110",
        UF_CRM_1745616497167: linkSimulacao,
        UF_CRM_1730922418894: valorImovel,
        OPPORTUNITY: valorFinaciamento,
        UF_CRM_1742567153: "354830",
        COMPANY_ID: "8322",
      },
    })
    .then(() => {
      triggerSuccess();
    })
    .catch(() => { })
    .finally(() => { });
};

export default BitrixApi;
